const STORAGE_KEY = 'builder:entryRoute'
const BASENAME = '/builder'

// Where the user was actually trying to go, remembered across the login round trip.
//
// A logged-out visitor never gets to keep their URL: with no session the business
// list is empty, so the route guard can't resolve `:businessID` and redirects to
// `/`, the catch-all redirects that to `/login`, and Auth0 is handed a fixed
// `redirectUri` with no `appState`. All three hops happen in the first render,
// before any login begins, and none of them carries the original address. So it
// has to be recorded before React mounts.
//
// Session storage rather than local: it is scoped to the tab that opened the link
// and dies with it, so a stale entry can never hijack a later login.

// Called once at boot, from the entry point, before the first render.
export function captureEntryRoute(): void {
  const { pathname, search } = window.location
  if (!pathname.startsWith(BASENAME)) {
    return
  }

  // Router paths are relative to the basename, which is not part of what
  // `history.push` takes.
  const route = pathname.slice(BASENAME.length) + search
  if (
    route === '' ||
    route === '/' ||
    route.startsWith('/login') ||
    route.startsWith('/invalid_user')
  ) {
    return
  }

  sessionStorage.setItem(STORAGE_KEY, route)
}

// Reads and clears, so the destination is only honoured for the login it belongs to.
export function takeEntryRoute(): string | undefined {
  const route = sessionStorage.getItem(STORAGE_KEY)
  sessionStorage.removeItem(STORAGE_KEY)
  return route ?? undefined
}
